const stateKeys = {}

const initialState = () => ({
  transferInfo: {
    newOwnerKnown: true,
    newOwnerEmail: null,
    newOwnerContinueContract: false,
    canContact: false
  },
  temporaryInfo: {
    newOwnerEmail: null,
    canContact: false
  },
  installationHandoverCode: null
})

export const state = () => initialState()

export const mutations = {
  clearStorage(state) {
    const freshState = JSON.parse(JSON.stringify(initialState()))
    for (const key in freshState) {
      state[key] = freshState[key]
    }
  },
  setTransferInfo(state, value) {
    for (const key in value) {
      if (state.transferInfo[key] !== value[key]) {
        state.transferInfo[key] = value[key]
      }
    }
  },

  setTemporaryInfo(state, value) {
    for (const key in value) {
      if (state.transferInfo[key] !== value[key]) {
        state.temporaryInfo[key] = value[key]
      }
    }
  },

  setInstallationHandoverCode(state, value) {
    state.installationHandoverCode = value
  }
}

export const actions = {
  clearStorage({ commit }) {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    commit('clearStorage')
  }
}
